import React from 'react';
import ReviewsItem from '../../../entities/review/ui/ReviewsItem';

const ReviewsList = ({ data, totalCount }) => {
  const shown = data?.items?.length || 0;
  const total = typeof totalCount === 'number' ? totalCount : shown;

  return (
    <div className='admin-list'>
      <div className="admin-list__header">
        <p className="admin-list__header-info">
          {shown === total ? `${total} відгуків` : `Знайдено ${shown} з ${total}`}
        </p>
        <div className="admin-list__header-func">
        </div>
      </div>

      <div className="admin-list__content">
        <ul className="admin-list__content-titles team-grid">
          <li>Автор</li>
          <li>Дата</li>
          <li>Статус</li>
          <li>Дія</li>
        </ul>
        <ul className="admin-list__content-items">
          {data?.items?.length > 0 ? (
            data.items.map((review) => (
              <ReviewsItem
                key={review.id || review.slug}
                review={review}
              />
            ))
          ) : (
            <li className="admin-list__empty">Нічого не знайдено</li>
          )}
        </ul>
      </div>

    </div>
  );
};

export default ReviewsList;